import React, { useEffect, useState, useMemo, useRef } from "react";
import { secondsToHHMM, timeToSeconds } from "../../../../Utilitie";
import axios from "axios";
import DownloadExcel from "../../../../Extra/DownloadExcel";

const tableHead = [
  "SR",
  "Date",
  "Div",
  "Direction",
  "Section",
  "Description of  OF ENGG Block",
  "FROM",
  "TO",
  "BLOCK BURST",
  "Granted Duration",
  "Availed Duration",
  "Actual PROGRESS/ OUTPUT",
  "Stipulated Output",
];

const ComEnggPosition = ({ data }) => {
  const urlPrefixBlock = process.env.REACT_APP_URL_BLOCK_PREFIX;
  const [machineData, setMachineData] = useState(null);
  const tableRef = useRef();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const fetchMachineData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${urlPrefixBlock}getmachinetype`);
      if (response.data.status === "ok") {
        setMachineData(response.data.machineTypes);
      }
    } catch (err) {
      console.error("Failed to fetch machine types:", err);
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMachineData();
  }, []);

  const filteredData = data.filter(
    (obj) =>
      (obj.Department === "ENGINEERING" ||
        obj.Department === "IRCON_ENGG" ||
        obj.Department === "CONST_ENGINEERING") &&
      obj.Type === "MACHINE",
  );
  //  Map & enrich filteredData with machineData
  const enrichedData = useMemo(() => {
    if (!machineData) return filteredData;

    return filteredData.map((item) => {
      let matched = null;

      // Search in machineData
      for (const dept of machineData) {
        if (dept.DEPARTMENT === item.Department) {
          for (const type of dept.children || []) {
            if (type.TYPE === item.Type) {
              for (const asset of type.children || []) {
                for (const data of asset.data || []) {
                  if (data.ASSET_DISCRIPTION === item.Block_Type) {
                    matched = asset.data?.[0] || null;
                    break;
                  }
                }
              }
            }
          }
        }
      }

      return {
        ...item,
        assetInfo: matched || {},
      };
    });
  }, [filteredData, machineData]);
  return (
    <div className="papaDiv">
      <div
        className="table-responsive"
        style={{ maxHeight: "800px", overflow: "auto" }}
      >
        <table
          className="table table-hover table-striped"
          style={{ fontSize: "13px" }}
          ref={tableRef}
        >
          <thead className="table-dark sticky-top" style={{ zIndex: 3 }}>
            <tr className="align-middle">
              {tableHead.map((head, i) => (
                <th
                  key={i}
                  colSpan={head === "Section" ? 2 : 1}
                  rowSpan={head === "Section" ? 1 : 2}
                >
                  {head}
                </th>
              ))}
            </tr>
            <tr>
              <td>From</td>
              <td>To</td>
            </tr>
          </thead>
          <tbody>
            {enrichedData.map((obj, i) => {
              const asset = obj.assetInfo || {};
              //   console.log(obj.assetInfo);
              return (
                <tr key={i}>
                  <td>{i + 1}</td>
                  <td>{obj.reportDate?.slice(0, 10)}</td>
                  <td>JBP</td>
                  <td>{obj.Direction}</td>
                  <td>{obj.From_Station}</td>
                  <td>{obj.To_Station}</td>
                  <td>{obj.Block_Type}</td>
                  <td>{obj.GrantedFrom}</td>
                  <td>{obj.GrantedTo}</td>
                  <td>
                    {secondsToHHMM(
                      timeToSeconds(obj.Availed_To) -
                        timeToSeconds(obj.GrantedTo),
                    )}
                  </td>
                  <td>
                    {secondsToHHMM(
                      timeToSeconds(obj.GrantedTo) -
                        timeToSeconds(obj.GrantedFrom),
                    )}
                  </td>
                  <td>
                    {secondsToHHMM(
                      timeToSeconds(obj.Availed_To) -
                        timeToSeconds(obj.Availed_From),
                    )}
                  </td>
                  <td>
                    {obj.Actual_Output_in_Meter}
                    {obj.Actual_Output_in_Meter && obj.Actual_Output
                      ? " - "
                      : ""}
                    {obj.Actual_Output}
                  </td>
                  <td>
                    {(
                      ((timeToSeconds(obj.Availed) -
                        Number(obj.No_Of_Demand_Agreed_GIVEN) *
                          obj?.assetInfo?.AssetReadyTime) /
                        3600) *
                      obj?.assetInfo?.Work_Done_Per_Hour
                    ).toFixed(2)}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <DownloadExcel tableRef={tableRef} fileName={`COM Position `} />
    </div>
  );
};

export default ComEnggPosition;
